import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import PropTypes from 'prop-types';
import TrackedButtonLink from "../common/TrackedButtonLink";
import {pushCardItem} from "../../utils/datalayer";

class InsightsCards extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    handleClick(e) {
        pushCardItem(e);
    }

    render() {
        const { data: insights } = this.props;

        return (
            <section className='container my-5'>
                <div className='row d-flex flex-column flex-md-row justify-content-center pt-4 pb-2'>
                    <div className="col-12 col-lg-7 mx-md-auto text-center lg-7 col">
                        <h2>Uncover Insights</h2>
                        <p>Access relevant resources to help you live a safer and more secure life.</p>
                    </div>
                </div>
                {insights && <div className='row d-flex flex-column flex-md-row justify-content-center pb-3'>
                    <div className="card-container">
                        {insights.map((insight, index) => (
                            <div className='card col-md-10 col-lg-4' key={`insight-article-preview-${index}`}>
                                <a href={`https://www.masterlock.com/insights/${insight.slug}`} onClick={(e) => this.handleClick(e)} target="_blank">
                                    <div className={`card-img-container`}>
                                        <img
                                            className="card-img-top--locked-ratio"
                                            src={insight.headerImage.image.uri}
                                            alt={insight.headerImage.altText}
                                        />
                                    </div>
                                    <div className="card-body">
                                        <h2>{insight.pageName}</h2>
                                        <span className="link-style">Read More</span>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>}
                <div className='row d-flex justify-content-center'>
                    <TrackedButtonLink
                        to="https://www.masterlock.com/insights"
                        target="_blank"
                        rel="noopener"
                        className="btn btn-primary btn-large">
                        <span className="fa fa-external-link mr-1"></span>Read All
                        Articles
                    </TrackedButtonLink>
                </div>
            </section>
        );
    }
}

InsightsCards.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            pageName: PropTypes.string,               // "pageName" is an optional string
            slug: PropTypes.string,                   // "slug" is an optional string
            readingTime: PropTypes.number,            // "readingTime" is an optional number
            published: PropTypes.string,              // "published" is an optional string
            headerImage: PropTypes.shape({            // "headerImage" is an optional object with specific properties
                image: PropTypes.shape({
                    id: PropTypes.string,                 // "id" is an optional string
                    title: PropTypes.string,              // "title" is an optional string
                    contentType: PropTypes.string,        // "contentType" is an optional string
                    description: PropTypes.string,        // "description" is an optional string
                    uri: PropTypes.string,                // "uri" is an optional string
                    filename: PropTypes.string            // "filename" is an optional string
                }),                                     // "image" is an optional object
                altText: PropTypes.string               // "altText" is an optional string
            })
        })
    ).isRequired  // 'data' is a required array of objects
};

export default branch({}, InsightsCards);



// WEBPACK FOOTER //
// ./src/pages/components/InsightsCards.js